/** @module Apparel/NewColorMaterialFromColor **/
define([
	"dojo/_base/declare",
	"csi",
	"csi/reflection",
	"csi/table/AggregateFrom",
	"csi/xml"
], function(declare,csi,reflection,AggregateFrom,xml) {
	var PROPAGATE = "Propagate3DMaterial";
	var PROPAGATE_FIELD = "3DPropagate3DMaterials";
	var COLOR_SPECIFICATION = "ColorSpecification";
	const PRODUCT_SOURCE = "ProductSource";
	const PRODUCT_SOURCES = "ProductSources";

	return declare(AggregateFrom, {
		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: set default name for Colorway on Colorway form - not popup Color table
			this.inherited(arguments);

			var	urlColor = view.getFixedValue ? view.getFixedValue("ColorSpecification") : null;
			if (urlColor) {
				view.defView.m_formData.setFieldInitialValue(xml.ATTR_NAME, view.cacheView.getNode(urlColor).$Name);
			}
		},

		_onAction: function() {
			// summary: colored materials have own images, but by default get images of unmanaged color
			if (this.m_bChecked) {
				this.m_writer.changeNode(this.m_urlNode).copyAttributeValue(this.m_nodeChecked, reflection.ATTR_IMAGES);
			}
		},

		/**
		 * Call server Java operation to create Color Material and propagate 3D Material if needed
		 * @param {array} val
		 */
		toWriterRequest: function() {
			var formData = this.getFormData();
			const productSourceFieldValue = this.getParent().ColorAllocationStatus === "ColorAllocationStatus:Allocation WIP" ? formData.getFieldValue(PRODUCT_SOURCE, true) : null;
			// Create Color Material using server operation
			return this.inherited(arguments)
				.addParameter(PROPAGATE, xml.ATTR_BOOLEAN, formData.getFieldValue(PROPAGATE_FIELD, true))
				.addParameter(COLOR_SPECIFICATION, xml.ATTR_REF, formData.getFieldValue(COLOR_SPECIFICATION, true))
				.addParameter(xml.ATTR_NAME, xml.ATTR_STRING, formData.getFieldValue(xml.ATTR_NAME, true))
				.addParameter(PRODUCT_SOURCES, xml.ATTR_REFLIST, productSourceFieldValue);
		}
	});
});